import { render, staticRenderFns } from "./ViewInvoicesCxC.vue?vue&type=template&id=e4d12704&scoped=true"
import script from "./ViewInvoicesCxC.vue?vue&type=script&lang=js"
export * from "./ViewInvoicesCxC.vue?vue&type=script&lang=js"
import style0 from "./ViewInvoicesCxC.vue?vue&type=style&index=0&id=e4d12704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d12704",
  null
  
)

export default component.exports